import type { User } from '@frontend/types';
import { canSeeRealmAdmin } from '@frontend/utils/adminHubAccess';
import { useAdminWidgetExpanded } from './hooks/useAdminWidgetExpanded';
import AssignEcosystemAdminsPanel from './realm/components/AssignEcosystemAdminsPanel';
import EcosystemOrchestrationPanel from './realm/components/EcosystemOrchestrationPanel';
import RealmIdentityPanel from './realm/components/RealmIdentityPanel';
import RealmPackagesPanel from './realm/components/RealmPackagesPanel';

interface RealmAdminPageProps {
  user: User | null;
}

export default function RealmAdminPage({ user }: RealmAdminPageProps) {
  const { expanded, toggleWidget } = useAdminWidgetExpanded(user, 'realm', {
    ecosystemOrch: true,
    packages: true,
    assignEcoAdmins: false,
    identity: true,
  });

  if (!canSeeRealmAdmin(user)) {
    return (
      <div className="tree-dashboard-panel">
        <h2>Realm Admin</h2>
        <p className="tree-dashboard-muted">You do not have permission to view this section.</p>
      </div>
    );
  }

  return (
    <div className="tree-dashboard-panel">
      <h2>Realm Admin</h2>
      <p className="tree-dashboard-muted">
        Manage ecosystems in this realm, assign ecosystem admins, and create or invite realm users.
      </p>

      <EcosystemOrchestrationPanel
        expanded={Boolean(expanded.ecosystemOrch)}
        onToggle={() => toggleWidget('ecosystemOrch')}
      />

      <RealmPackagesPanel
        expanded={Boolean(expanded.packages)}
        onToggle={() => toggleWidget('packages')}
      />

      <AssignEcosystemAdminsPanel
        expanded={Boolean(expanded.assignEcoAdmins)}
        onToggle={() => toggleWidget('assignEcoAdmins')}
      />

      <RealmIdentityPanel
        expanded={Boolean(expanded.identity)}
        onToggle={() => toggleWidget('identity')}
      />
    </div>
  );
}
